import { InMemoryCache } from '@apollo/client';
import { GET_ACCOUNT_TO_RECOVER } from 'graphqls/accountRecovery';

export const initializeAccountToRecover = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_ACCOUNT_TO_RECOVER,
    data: {
      accountToRecover: null,
    },
  });
};

export default {
  resolvers: {
    Mutation: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      setAccountToRecover: (_, { accountToRecover }, { cache }): any => {
        cache.writeQuery({
          query: GET_ACCOUNT_TO_RECOVER,
          data: {
            accountToRecover: {
              __typename: 'PartialBauAccountDetails',
              ...accountToRecover,
            },
          },
        });

        return accountToRecover;
      },
    },
  },
};
